// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"5297af2e","119":"fae1c0ab","152":"70f71889","322":"7b3cb644","436":"55fef946","453":"c639e721","502":"1bbe0075","535":"e4aa35b0","604":"b72038ce","717":"34c98c1f","839":"4f308709","899":"31fbd477","941":"377af2d2","970":"32ed81b9","978":"22a8bc1c"}[chunkId] + ".chunk.js";
};